import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, useRoutes } from "react-router-dom";

import Layout from "./layouts/Layout";

// pages
import Product from "./pages/product";
import ThankYou from "./pages/thankYou";

// ----------------------------------------------------------------------
const ROUTE_MENU = [];

export default function Router() {
  const [level, setLevel] = useState();

  const COMMON_ROUTE = [
    // {
    //   path: "",
    //   element: <Layout />,
    //   children: [{ path: "", element: <Home /> }],
    // },
    {
      path: "",
      element: <Layout />,
      children: [
        { path: "", element: <Product /> },
        { path: "/:promoterCode", element: <Product /> },
        // { path: "/courses-2", element: <Courses2 /> },
        // { path: "/about", element: <AboutUs /> },
        // // { path: "/404", element: <NotFound /> },
        // { path: "/contact", element: <Contact /> },
        { path: "/thank-you", element: <ThankYou /> },
        // { path: "register", element: <Register /> },
        // { path: "404", element: <NotFound /> },
        // {
        //   path: "/",
        //   element: <Navigate to={""} replace />,
        // },
        // {
        //   path: "/home",
        //   element: <Navigate to={""} replace />,
        // },
        // {
        //   path: "/index",
        //   element: <Navigate to={""} replace />,
        // },
        { path: "*", element: <Navigate to="/404" /> },
      ],
    },
    { path: "*", element: <Navigate to="/404" replace /> },
  ];

  return useRoutes(COMMON_ROUTE);
  // return useRoutes(FILTER_ROUTE.concat(COMMON_ROUTE));
}
